import { Feature, FeatureCollection, LineString, MultiPolygon, Point, Polygon } from '@turf/turf';
import { IStadiumProperties } from './model/authority-tiles/IStadiumProperties';
import { IAirspaceProperties } from './model/authority-tiles/IAirspaceProperties';
import { INSUFRProperties } from './model/authority-tiles/INSUFRProperties';
import { IPartTimeNSUFRProperties } from './model/authority-tiles/IPartTimeNSUFRProperties';
import { IDCFRZProperties } from './model/authority-tiles/IDCFRZProperties';
import { ISpecialUseProperties } from './model/authority-tiles/ISpecialUseProperties';
import { ILAANCProperties } from './model/authority-tiles/ILAANCProperties';
import { IActiveAirspaceProperties } from './model/authority-tiles/IActiveAirspaceProperties';
import { INationalParkProperties } from './model/authority-tiles/INationalParkProperties';
import { IWildernessAreaProperties } from './model/authority-tiles/IWildernessAreaProperties';
import { IWildlifeRefugeProperties } from './model/authority-tiles/IWildlifeRefugesProperties';
import { ITFRProperties } from './model/authority-tiles/ITFRProperties';
import { IAirspaceBoundaryProperties } from './model/authority-tiles/IAirspaceBoundaryProperties';
import { IMilitaryTrainingRouteProperties } from './model/authority-tiles/IMilitaryTrainingRouteProperties';
import { IRecreationalFixedFlyerSiteProperties } from './model/authority-tiles/IRecreationalFixedFlyerSiteProperties';
import { IAirportProperties } from './model/authority-tiles/IAirportProperties';

// TODO: not loving this giant union, but too invasive to change it ATM
export type IAuthorizableProperties = IStadiumProperties | IAirspaceProperties | INSUFRProperties | IPartTimeNSUFRProperties | IDCFRZProperties | ISpecialUseProperties | ILAANCProperties | INationalParkProperties | IWildernessAreaProperties | IWildlifeRefugeProperties | ITFRProperties | IAirspaceBoundaryProperties | IMilitaryTrainingRouteProperties | IRecreationalFixedFlyerSiteProperties | IAirportProperties;

export type IAuthorizableGeometry = Point | Polygon | MultiPolygon | LineString;

export class AuthorizationFeatureCollection implements FeatureCollection<IAuthorizableGeometry, IAuthorizableProperties> {
    type: 'FeatureCollection' = 'FeatureCollection';
    features: Feature<IAuthorizableGeometry, IAuthorizableProperties>[];
    constructor({ features }: { features: Feature<IAuthorizableGeometry, IAuthorizableProperties>[]}){
        this.features = features;
    }
    getAirspaceFeatures = (): Feature<Polygon | MultiPolygon, IActiveAirspaceProperties>[] => {
        return this.features.filter(f => f.properties!.source === 'airspace') as Feature<Polygon | MultiPolygon, IAirspaceProperties>[];
    }

    getLAANCFeatures = (): Feature<Polygon | MultiPolygon, ILAANCProperties>[] => {
        return this.features.filter(f => f.properties!.source === 'uasfm+airspace') as Feature<Polygon | MultiPolygon, ILAANCProperties>[];
    }

    getStadiumPoints = (): Feature<Point, IStadiumProperties>[] => {
        return this.features.filter(f => f.properties!.source === 'stadiums') as Feature<Point, IStadiumProperties>[];
    }
    getNationalParks = (): Feature<Polygon | MultiPolygon, INationalParkProperties>[] => {
        return this.features.filter(f => f.properties!.source === 'national-parks') as Feature<Polygon | MultiPolygon, INationalParkProperties>[];
    }
    getWildernessAreas = (): Feature<Polygon | MultiPolygon, IWildernessAreaProperties>[] => {
        return this.features.filter(f => f.properties!.source === 'wilderness-areas') as Feature<Polygon | MultiPolygon, IWildernessAreaProperties>[];
    }
    getWildlifeRefuges = (): Feature<Polygon | MultiPolygon, IWildlifeRefugeProperties>[] => {
        return this.features.filter(f => f.properties!.source === 'wildlife-refuges') as Feature<Polygon | MultiPolygon, IWildlifeRefugeProperties>[];
    }
}
